import { useState } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { BottomModal } from '../../shared/BottomModal';
import config from '../../../config';
import { toast } from 'react-toastify';

const configReport = [
  { message: 'Фейк' },
  { message: 'Неприемлемый контент' },
  { message: 'Возраст' },
  { message: 'Оскорбления' },
  { message: 'Поведение вне MYTA' },
  { message: 'Мошенничество или спам' },
];

export function ReportUser({ userId, onTriggerClick }) {
  const axiosPrivate = useAxiosPrivate();
  const [isLoading, setIsLoading] = useState(false);

  const [isOpen, onClose] = useState(false);
  const [reported, setReported] = useState({
    isReported: false,
  });

  const handleSendReportToUser = async (reason, targetUserId) => {
    try {
      await axiosPrivate.post(config.API.USERS.REPORT, {
        targetUserId,
        reason,
        details: '',
      });

      setReported((prev) => ({ ...prev, isReported: true }));
      toast.success('Жалоба отправлена');
    } catch (error) {
      console.log(error);

      const message = error?.response?.data?.message;

      toast.error(message || 'Ошибка при отправке жалобы');
    }
  };

  return (
    <>
      <div
        className="w-full border-b border-[#233636] h-[60px] flex items-center justify-between pl-[16px] pr-[16px]"
        onClick={() => {
          onTriggerClick?.();
          onClose(true);
        }}
      >
        <span>Пожаловаться</span>
        <img src="/icons/report.svg" />
      </div>

      <BottomModal isOpen={isOpen} onClose={onClose}>
        <div className="px-4 text-white overflow-auto mb-6">
          {reported.isReported ? (
            <div className="flex flex-col justify-start items-center w-full mt-[40px]">
              <img src="/icons/report_sent.svg" className="w-[80px] h-[80px]" />
              <p className="text-center w-[300px] mt-[30px] font-semibold text-[22px]">Ваша жалоба отправлена</p>
              <p className="text-center text-[16px] mt-[20px] font-normal pl-2 pr-2">
                Мы внимательно рассмотрим вашу жалобу и примем соответствующие меры. Спасибо, что помогаете сделать наше
                приложение лучше
              </p>
            </div>
          ) : (
            <>
              <div className="flex flex-col justify-start items-center w-full">
                <p className="font-semibold text-[22px]">Пожаловаться</p>
                <p className="font-normal text-[16px]">Это останется между нами</p>
              </div>

              <div className="w-full pr-[16px] pl-[16px]">
                {configReport.map(({ message }, index) => (
                  <div
                    className={`h-[60px] flex items-center ${configReport.length - 1 == index ? '' : 'border-b border-[#6D6D6D]'}`}
                    onClick={() => handleSendReportToUser(message, userId)}
                  >
                    <span>{message}</span>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </BottomModal>
    </>
  );
}
